import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

import type {
  AvailabilityFilter,
  FinishFilter,
  MediumFilter,
  MultiOptionFilter,
  OrderSort,
  ReleaseFilter,
  ShippingFilter,
  SingleOptionFilter,
} from '../types/Filters';
import { useMultiOptionQueryParam } from './useMultiOptionQueryParam';
import { usePathname } from './usePathname';
import { useQueryParam } from './useQueryParam';

export type ProductFiltersController = {
  availability: SingleOptionFilter<AvailabilityFilter>;
  finish: MultiOptionFilter<FinishFilter>;
  mediums: MultiOptionFilter<MediumFilter>;
  order: SingleOptionFilter<OrderSort>;
  release: MultiOptionFilter<ReleaseFilter>;
  searchTerm: SingleOptionFilter<string>;
  shipping: SingleOptionFilter<ShippingFilter>;

  isInteractedWith: boolean;
  setIsInteractedWith: (value: boolean) => void;

  clearAll: () => void;
};

export const useProductFilters = (): ProductFiltersController => {
  const router = useRouter();
  const pathname = usePathname();

  const [isInteractedWith, setIsInteractedWith] = useState(false);

  const availability = useQueryParam<AvailabilityFilter>({
    key: 'availability',
  });

  const finish = useMultiOptionQueryParam<FinishFilter>({
    key: 'finish',
  });

  const mediums = useMultiOptionQueryParam<MediumFilter>({
    key: 'medium',
  });

  const order = useQueryParam<OrderSort>({
    key: 'order',
    fallbackValue: 'Relevance',
  });

  const release = useMultiOptionQueryParam<ReleaseFilter>({
    key: 'release',
  });

  const searchTerm = useQueryParam<string>({
    key: 'q',
    fallbackValue: '',
  });

  const shipping = useQueryParam<ShippingFilter>({
    key: 'shipping',
    fallbackValue: 'All',
  });

  const clearAll = useCallback(() => {
    router.push(pathname, undefined, { shallow: true });
  }, []);

  return {
    availability,
    finish,
    mediums,
    order,
    release,
    searchTerm,
    shipping,
    isInteractedWith,
    setIsInteractedWith,
    clearAll,
  };
};
